<template>
  <div>
    <v-card-text>
      <v-list
        two-line
        subheader>
        <v-subheader>{{ $t('purchase.call.informations') }}</v-subheader>
        <v-list-item
          v-for="item in list" :key="item.key">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon
                v-if="item.icon">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <date-formatter v-if="item.type === 'date'" :value="item.value"></date-formatter>
                <minute v-else-if="item.type === 'minute'" :value="item.value"></minute>
                <price v-else-if="item.type === 'price'" :value="item.value"></price>
                <span v-else>{{ item.value || $t('purchase.call.none') }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title>{{ $t(item.key) }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-expansion-panel class="elevation-0" v-if="callDetails.id">
      <v-expansion-panel-content>
        <div slot="header">{{ $t('purchase.call.debug') }}</div>
        <v-card>
          <v-card-text class="grey lighten-3">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <h4 class="subheading">{{ $t('purchase.call.caller') }}</h4>
                <call-timeline :data="callDetails.caller_states || []"></call-timeline>
              </v-flex>
              <v-flex xs12 md6>
                <h4 class="subheading">{{ $t('purchase.call.callee') }}</h4>
                <call-timeline :data="callDetails.callee_states || []"></call-timeline>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card-row actions>
      <v-dialog
        v-model="modal">
        <v-btn
          v-if="isInProgress && canHangup"
          slot="activator"
          error light>
          {{ $t('purchase.call.hangup') }}
        </v-btn>
        <v-card>
          <v-card-text>
            {{ $t('purchase.call.hangupText') }}
          </v-card-text>
          <v-card-row actions>
            <v-btn
              @click.native.stop="hangup()"
              :loading="hangupLoading"
              error light>
              {{ $t('purchase.call.hangup') }}
            </v-btn>
          </v-card-row>
        </v-card>
      </v-dialog>

      <template v-if="callDetails.completed && $can('listen', 'call')">
        <call-player :purchase="purchase"></call-player>
        <v-btn
          class="ml-2"
          :loading="downloading"
          primary light
          @click.native="download">
          {{ $t('purchase.call.download') }}
        </v-btn>
      </template>

      <slot name="actions"></slot>
    </v-card-row>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { Date as DateFormatter, Minute, Price } from '@/components/formatters'
  import CallTimeline from '@/components/CallTimeline.vue'
  import CallPlayer from '@/components/purchase/CallPlayer.vue'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      Price,
      DateFormatter,
      Minute,
      CallTimeline,
      CallPlayer
    },
    mixins: [purchase],
    data () {
      return {
        modal: false,
        downloading: false
      }
    },
    computed: {
      ...mapGetters({
        hangupLoading: 'skiliko/call/isLoading'
      }),
      callInformations () {
        return this.service
      },
      callDetails () {
        return this.callInformations.call
      },
      canHangup () {
        return +new Date(this.purchase.service.call_at) <= +new Date()
      },
      list () {
        return [
          { key: 'purchase.call.starts', value: this.callInformations.call_at, type: 'date', icon: 'date_range' },
          { key: 'purchase.call.pricePerMin', value: this.callInformations.per_minute_price, type: 'price', icon: 'attach_money' },
          { key: 'purchase.call.timeLimit', value: this.callDetails.time_limit || this.purchase.user.phone_seconds_available, type: 'minute', icon: 'timer' },
          this.isFinished ? { key: 'purchase.call.duration', value: this.callDetails.duration || null, type: 'minute', icon: 'timelapse' } : null,
          this.isFinished ? { key: 'purchase.call.statusLabel', value: this.callDetails.status && this.$t(`purchase.call.status.${this.callDetails.status}`), icon: 'assignment_late' } : null,
          this.callDetails.error ? { key: 'purchase.call.error', value: this.callDetails.error, icon: 'error' } : null
        ].filter(e => e && !!e.value)
      }
    },
    methods: {
      ...mapActions({
        _hangup: 'skiliko/call/hangup',
        _fetchAudio: 'skiliko/call/fetchAudio'
      }),
      hangup () {
        this._hangup({ id: this.purchase.id })
          .then(_ => (this.modal = false))
      },
      download () {
        this.downloading = true
        this._fetchAudio({ id: this.purchase.id })
          .then(audio => {
            this.src = audio.endpoint
            const link = document.createElement('a')
            link.download = `${this.purchase.id}.wav`
            link.href = audio.endpoint
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            alert(this.$t('purchase.call.downloadStart'))
            this.downloading = false
          })
          .catch(alert)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Call.vue